<template>
  <artmisads-modal title="Product Details" v-model:open="visible" :footer="null" :width="900" @cancel="closeModal">
    <div class="publisher-details">

      <div class="publisher-header">
        <LogoImage :logoUrl="modalRecord.publisherAvatarUrl" :brandName="modalRecord.publisherName" />
        <a href="javascript:void(0)" class="product-link">{{ modalRecord.publisherName }}</a>
      </div>

      <artmisads-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
        :scroll="{ x: 730 }"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'product'">
            <div class="product-cell">
            <div >
              <LogoImage :logoUrl="record.imageUrl" :brandName="record.productTitle" />
            </div>
           
            <div>
              <a-tooltip :title="record.productTitle" placement="top">
                <div class="product-link">
                  {{ record.productTitle }}
                </div>
              </a-tooltip>
              <div class="asin-link">
                {{ record.asin }}
              </div>
            </div>
            <!-- <a href="javascript:void(0)" class="product-link">{{ record.productTitle }}</a> -->
          </div>
          </template>
          <template v-if="column.key === 'clicks'">
            <div class="metric-cell">
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                 <span class="item-text">Attribution</span>
               </div>
              </div>
              <div class="num">
                {{ record.attributionClicks||0 }}
              </div>
            </div>
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                 <span class="item-text">Associate</span>
               </div>
              </div>
              <div class="num">
                {{ record.associateClicks||0 }}
              </div>
            </div>
          </div>
          </template>
          <template v-if="column.key === 'sales'">
            <div class="metric-cell">
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                 <span class="item-text">Attribution</span>
               </div>
              </div>
              <div class="num">
              {{ currency }}  {{ record.attributionSalesAmount||0 }}
              </div>
            </div>
            <div class="info-item-row">
              <div class="info-item-row" >
               <div class="item-row">
                 <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                 <span class="item-text">Associate</span>
               </div>
              </div>
              <div class="num">
              {{ currency }}  {{ record.associateSalesAmount||0 }}
              </div>
            </div>
          </div>
          </template>
        </template>
      </artmisads-table>
    </div>
  </artmisads-modal>
</template>

<script setup>
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"
import LogoImage from "@/components/LogoImage.vue"
import { sellerCpcApi } from "~/server"
import { CURRENCY_MAPPER } from "@/contants/common"
import { useUserInfoStore } from "@/storeData"
const { t } = useI18n()
const user = useUserInfoStore()
const currency = CURRENCY_MAPPER[user.userInfo?.countryCode]?.currency || '$'
const visible = ref(false)
const modalRecord = ref({
  
})

const columns = computed(() => [
  { title: t("seller.cpcPublisherDetailsModal.colProduct"), dataIndex: "productName", key: "product", width: 330 },
  { title: t("seller.cpcPublisherDetailsModal.colClicks"), dataIndex: "clicks", key: "clicks", width: 200 },
  { title: t("seller.cpcPublisherDetailsModal.colSales"), dataIndex: "sales", key: "sales", width: 220 },
])

const dataSource = ref([
 
])

const openModal = (record) => {
  modalRecord.value = record 
  visible.value = true
  getPublisherDetails()
}
const getPublisherDetails = () => {
  sellerCpcApi.getCpcCampaignsPublishersProducts({ campaignId: modalRecord.value.campaignId, publisherId: modalRecord.value.publisherId }).then(res => {
    
    dataSource.value = res.data
  })
}
const closeModal = () => {
  visible.value = false
}

defineExpose({
  openModal,
  closeModal,
})
</script>

<style scoped lang="less">
.publisher-details {
  h3 {
    margin: 0 0 14px;
    color: #374151;
    font-size: 16px;
  }
}

.publisher-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.publisher-name {
  font-weight: 600;
  color: #374151;
}

.product-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}


.product-link {
  color: #4b5563;
  text-decoration: underline;
  line-height: 1.3;
  display: block;
  width: 300px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.asin-link{
  font-family: Sora;
font-weight: 500;
font-size: 12px;
leading-trim: NONE;
line-height: 16px;
letter-spacing: 0.3px;
color: rgba(15, 6, 41, 0.5);
margin-top: 6px;

}

.product-link {
  color: #4b5563;
  text-decoration: underline;
  line-height: 1.3;
}

.metric-cell {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.info-item-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .item-row {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #f1f0f5;
    min-width: 111px;

    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }
.dot {
  margin-right: 6px;
}

.num {
  margin-left: 8px;
  color: #111827;
}
</style>
